<template>
  <div class="pa-4">
    <vue-table :data="data" :headers="headers" :loading.sync="loading" :props.sync="tableProps" group-by="advertise_id"
               show-group-by @change="onPagination">
      <template v-slot:filters="{props, perPage}">
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" lg="3" md="4">
            <v-text-field v-model="props.search" append-icon="mdi-magnify" class="rounded-lg" clearable dense
                          hide-details label="جستجو" outlined/>
          </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="4">
            <v-select v-model="props.days" :items="weekDayItems" :menu-props="{offsetY: true}" class="rounded-lg"
                      clearable dense hide-details label="روزهای هفته" outlined/>
          </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="4">
            <custom-date-picker v-model="props.start_at" dense format="YYYY-MM-DD" hide-details
                                label="از تاریخ" nullable outlined type="date" wrapper-class="rounded-lg"/>
          </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="4">
            <custom-date-picker v-model="props.end_at" dense format="YYYY-MM-DD" hide-details label="تا تاریخ" nullable
                                outlined type="date" wrapper-class="rounded-lg"/>
          </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="4">
            <v-select v-model="props.order_by" :items="viewItems" :menu-props="{offsetY: true}" class="rounded-lg"
                      clearable dense hide-details label="بازدید ساعتی" outlined/>
          </v-col>
        </v-row>
      </template>

      <template v-slot:group.header="row">
        <td :colspan="row.headers.length">
          <v-btn class="me-2" icon @click="row.toggle()">
            <v-icon>mdi-{{ row.isOpen ? 'chevron-up' : 'chevron-down' }}</v-icon>
          </v-btn>
          <span>دسته‌بندی آگهی: {{ row.group }}</span>

          <v-tooltip top>
            <template v-slot:activator="{on, attrs}">
              <v-btn class="ms-2" icon v-bind="attrs" @click="row.remove()" v-on="on">
                <v-icon>mdi-ungroup</v-icon>
              </v-btn>
            </template>

            نمایش ساده
          </v-tooltip>
        </td>
      </template>

      <template v-slot:created_at="{item}">
        <div v-html="available_filter(item.created_at)"></div>
      </template>

      <template v-slot:is_ladder="{item}">
        <v-icon :color="item.is_ladder ? 'success' : 'red'">mdi-{{ item.is_ladder ? 'check' : 'close' }}</v-icon>
      </template>
    </vue-table>
  </div>
</template>

<script>
import {Axios2} from "@/main";
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";

export default {
  name: "adAnalyzerId",
  components: {CustomDatePicker},

  created() {
    this.fetch()
  },

  data() {
    return {
      data: {},
      loading: false,
      weekDayItems: ['شنبه', 'یک‌شنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'],
      headers: [
        // {value: 'index', text: 'ردیف', sortable: false, align: 'center'},
        {value: 'id', text: 'شناسه', sortable: false, groupable: false, align: 'center'},
        {value: 'advertise_id', text: 'شناسه آگهی', align: 'center'},
        {value: 'created_at', text: 'تاریخ ایجاد', sortable: false, groupable: false, align: 'center'},
        {value: 'view', text: 'بازدید', sortable: false, groupable: false, align: 'center'},
        {value: 'total_view', text: 'بازدید کلی', sortable: false, groupable: false, align: 'center'},
        {value: 'is_ladder', text: 'نردبان', sortable: false, groupable: false, align: 'center'},
      ],
      tableProps: {
        page: 1,
        length: 100
      },
      viewItems: [
        {value: 'less', text: 'کمترین'},
        {value: 'more', text: 'بیشترین'},
      ]
    }
  },

  computed: {
    listId() {
      return this.$route.params.id;
    }
  },

  methods: {
    fetch(params = this.tableProps) {
      this.loading = true

      Axios2.get(`divar/analysis/${this.listId}`, {
        params
      })
        .then(({data}) => {
          this.data = {
            data: Object.keys(data.data).reduce((acc, cur) => {
              data.data[cur].forEach(item => {
                acc.push(item)
              })

              return acc
            }, [])
          }
        })
        .finally(() => this.loading = false)
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e
      }

      this.fetch(props)
    },
    available_filter(input) {
      const moment = require('moment-jalaali')

      return moment(input).format('ddd jYYYY-jMM-jDD ساعت‌HH:mm:ss').split(' ').map(av => {
        return `<div>${av}</div>`
      }).join('')
    }
  }
}
</script>

<style scoped>

</style>